import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-primary-900 overflow-hidden">
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-80 h-80 bg-accent-500/[0.03] rounded-full translate-x-1/3 -translate-y-1/3 blur-3xl"></div>

      <div className="relative z-10 max-w-[700px] mx-auto px-8 text-center">
        {String(t('coursesAdvanced.cta.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400/60 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
        <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-4">
          {t('coursesAdvanced.cta.title')}
        </h2>
        <div className="gold-line mx-auto mb-6"></div>
        {String(t('coursesAdvanced.cta.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-300 leading-relaxed tracking-[0.04em] mb-10 max-w-lg mx-auto">{__s}</p>))}

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6">
          <Link
            to="/brochure"
            className="btn-glow px-8 py-3.5 bg-accent-500/90 hover:bg-accent-500 text-primary-900 text-[15px] tracking-[0.1em] font-medium text-center transition-all duration-300 whitespace-nowrap"
          >
            {t('coursesAdvanced.cta.brochure')}
          </Link>
          <Link
            to="/consultation"
            className="btn-glow px-8 py-3.5 border border-accent-500/50 text-accent-300 hover:text-accent-200 hover:border-accent-400 hover:bg-accent-500/8 text-[15px] tracking-[0.1em] text-center transition-all duration-300 whitespace-nowrap"
          >
            {t('coursesAdvanced.cta.consultation')}
          </Link>
        </div>

        {String(t('coursesAdvanced.cta.note')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-500 tracking-[0.04em] mb-8">{__s}</p>))}

        {/* Seminar Link */}
        <Link
          to="/seminar"
          className="inline-flex items-center gap-2 text-[15px] text-accent-400 hover:text-accent-300 tracking-[0.08em] transition-colors duration-300 group"
        >
          <i className="ri-calendar-event-line"></i>
          <span>{t('coursesAdvanced.cta.seminarLink')}</span>
          <i className="ri-arrow-right-line text-xs transition-transform duration-300 group-hover:translate-x-1"></i>
        </Link>
      </div>
    </section>
  );
}
